
import { Vue, Component } from 'vue-property-decorator';
import { Tab, Tabs } from 'vant';
import { getRankList, getUserInfo } from '../api/index';
import List from '../components/List.vue';

Vue.use(Tab);
Vue.use(Tabs);
@Component({
  components: {
    List,
  },
})
export default class RankList extends Vue {
  activeItem: number = 0;
  date = 8;
  userInfo: any = {}; // 用户信息
  defaultImg = require('../assets/default.png');
  showUserData = false;
  dateArr = [
    {
      id: 8,
      text: '6月08日',
    },
    {
      id: 9,
      text: '6月09日',
    },
    {
      id: 10,
      text: '6月10日',
    },
  ];
  userData: any = {}; // 答题信息
  config = {
    one: { text: '名次', field: '' },
    two: { text: '昵称', field: 'nickname' },
    three: { text: '手机号', field: 'phone' },
    four: { text: '得分', field: 'score' },
    five: { text: '用时', field: 'answer_time' },
  };
  created() {
    const time1 = new Date('2022/06/09').getTime();
    const time2 = new Date('2022/06/10').getTime();
    const time3 = new Date('2022/06/11').getTime();
    console.log(Date.now());
    if (Date.now() < time1) {
      this.activeItem = 0;
      this.date = 8;
    } else if (Date.now() < time2) {
      this.activeItem = 1;
      this.date = 9;
    } else if (Date.now() < time3) {
      this.activeItem = 2;
      this.date = 10;
    }
    this.handleClickItem(this.activeItem, this.date);
    // this.fetchData();
  }
  async fetchData() {
    this.userData = {};
    this.showUserData = false;
    const res = await getRankList(this.date, 1);
    console.log('答题信息', res.data);
    if (res.data.one.length !== 0) {
      // console.log('进不来？');
      this.showUserData = true;
      this.userData = res.data.one[0];
    }
    // getUserInfo().then((res: any) => {
    //   if (res.code === 200) {
    //     this.userInfo = res.data;
    //   }
    // });
  }
  handleClickItem(index: number, date: any) {
    this.activeItem = index;
    this.date = date;
    this.fetchData();
  }
  // 转换时间
  transformDate(t: any) {
    return `${Math.floor(t / 60)} '${((t % 60) / 100).toFixed(2).slice(-2)}"`;
  }
}
